import React, { useRef, useState, useEffect } from "react";
import AdminCard from "../components/AdminCard";
import { useAppDispatch, useAppSelector } from "../provider/app/hooks";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  obtenerListadoGrupos,
  obtenerListadoUsuarios,
  obtenerListadoInvitaciones,
  obtenerListadoLicencias,
} from "../service/apiService";
import { setItems as setGroupsItems } from "../provider/Slice/GruposSlice";
import { setItems as setUsersItem } from "../provider/Slice/UserSlice";
import { setItems as setInvitacionsItem } from "../provider/Slice/InvitationSlice";
import { setItems as setLicensesItem } from "../provider/Slice/LicenceSlice";

export default function AdminDashboard() {
  const dispatch = useAppDispatch();

  const grupos = useAppSelector((state) => state.StoreGrupos.data);
  const usuarios = useAppSelector((state) => state.StoreUsuarios.data);
  const invitaciones = useAppSelector((state) => state.StoreInvitaciones.data);
  const licencias = useAppSelector((state) => state.StoreLicencias.data);

  const [newInvitaciones, setNewInvitaciones] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);

  useEffect(() => {
    cargarInvitaciones();
  }, [invitaciones]);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const cargarInvitaciones = async () => {
    try 
    {
      const listInvitaciones = invitaciones.map((item) => ({
        id: item.id,
        name: item.user_fullname +
          " fue invitado a pertenecer al grupo: '" +
          item.grupo_name +
          "'",
        status: item.status,
        }));

        setNewInvitaciones(listInvitaciones);
    } catch (ex) {
      console.log({ ex });
    }
  };

  const cargarListas = async () => {
    try {
      setOpenLoader(true);
      const [grupos, usuarios, invitaciones, licencias] = await Promise.all([
        obtenerListadoGrupos(),
        obtenerListadoUsuarios(),
        obtenerListadoInvitaciones(),
        obtenerListadoLicencias(),
      ]);

      dispatch(setGroupsItems(grupos.data));
      dispatch(setUsersItem(usuarios.data));
      dispatch(setInvitacionsItem(invitaciones.data));
      dispatch(setLicensesItem(licencias.data));
    } catch (ex) {
      console.log(ex);
    } finally {
      setOpenLoader(false);
    }
  };

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="h-[calc(82vh)] w-full flex flex-col px-[100px] py-8 mx-auto lg:py-0 overflow-y-auto">
        
        {/* Loader */}
        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={openLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>


        <div className="grid grid-cols-2 gap-4 mt-[20px] mb-[30px]">
          <AdminCard
            name="Grupos"
            data={grupos}
            button1_name="Miembros"
            button2_name="Invitar"
            reload={cargarListas}
          />

          <AdminCard
            name="Usuarios"
            data={usuarios}
            button1_name="Grupos"
            button2_name="Licencias"
            reload={cargarListas}
          />

          <AdminCard
            name="Invitaciones"
            data={newInvitaciones}
            button1_name={null}
            button2_name="Remover"
            reload={cargarListas}
          />

          <AdminCard
            name="Licencias"
            data={licencias}
            button1_name={null}
            button2_name="Uso"
            reload={cargarListas}
          />
        </div>

      </div>
    </section>
  );
}
